var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',_vm._g(_vm._b({ref:_vm.ref,attrs:{"credits":false,"force-revert":true,"label-idle":_vm.labelIdle,"server":_vm.filePondServer},on:{"init":_vm.handleFilePondInit}},'file-pond',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }